import { render, staticRenderFns } from "./Release.vue?vue&type=template&id=d62137a6&scoped=true&"
import script from "./Release.vue?vue&type=script&lang=js&"
export * from "./Release.vue?vue&type=script&lang=js&"
import style0 from "./Release.vue?vue&type=style&index=0&id=d62137a6&prod&lang=css&"
import style1 from "./Release.vue?vue&type=style&index=1&id=d62137a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62137a6",
  null
  
)

export default component.exports